module.exports = __webpack_public_path__ + "img/top-bar.4cc4d2f7.png";